import { render } from "./ApplicationLogo.vue?vue&type=template&id=3ac4aa20"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/ApplicationLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ac4aa20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ac4aa20', __exports__)) {
    api.reload('3ac4aa20', __exports__)
  }
  
  module.hot.accept("./ApplicationLogo.vue?vue&type=template&id=3ac4aa20", () => {
    api.rerender('3ac4aa20', render)
  })

}


export default __exports__